// Espelho do Campaigns::ReleaseWindow (backend). Janela SEMANAL de liberação do
// hold de campanha. Default seguro 08:00-18:00 nos 7 dias — barra release de
// madrugada. Usado pelo wizard e pelo builder (mesmo contrato de payload).
export const RELEASE_WINDOW_DEFAULT_OPEN_HOUR = 8;
export const RELEASE_WINDOW_DEFAULT_CLOSE_HOUR = 18;

// day_of_week 0=domingo … 6=sábado (mesma convenção do Ruby wday / WorkingHour).
export const buildDefaultReleaseWindow = () =>
  Array.from({ length: 7 }, (_, dayOfWeek) => ({
    day_of_week: dayOfWeek,
    open_hour: RELEASE_WINDOW_DEFAULT_OPEN_HOUR,
    open_minutes: 0,
    close_hour: RELEASE_WINDOW_DEFAULT_CLOSE_HOUR,
    close_minutes: 0,
    closed_all_day: false,
  }));

const normalizeDay = day => ({
  day_of_week: Number(day.day_of_week),
  open_hour: Number(day.open_hour) || 0,
  open_minutes: Number(day.open_minutes) || 0,
  close_hour: Number(day.close_hour) || 0,
  close_minutes: Number(day.close_minutes) || 0,
  closed_all_day: Boolean(day.closed_all_day),
});

// A janela é igual ao default seguro? (pra OMITIR do payload — mantém as
// campanhas existentes idênticas e o lock spec do compile enxuto).
export const isDefaultReleaseWindow = window => {
  if (!Array.isArray(window) || window.length !== 7) return true;
  const byDay = new Map(
    window.map(day => [Number(day.day_of_week), normalizeDay(day)])
  );
  return buildDefaultReleaseWindow().every(def => {
    const got = byDay.get(def.day_of_week);
    return (
      got &&
      !got.closed_all_day &&
      got.open_hour === def.open_hour &&
      got.open_minutes === def.open_minutes &&
      got.close_hour === def.close_hour &&
      got.close_minutes === def.close_minutes
    );
  });
};

// Chaves do payload (send_message) a partir do modo + janela. O modo vai
// SEMPRE explícito: chave ausente = campanha legada e resolve pra 'send' no
// backend — omitir 'hold' viraria 'send' silencioso. A janela só acompanha o
// hold, e só quando difere do default. Espelho do open_conversation_keys do
// Campaigns::Builder::GraphCompiler.
export const buildOpenConversationKeys = (mode, window) => {
  const resolvedMode = mode || 'hold';
  const keys = { on_open_conversation: resolvedMode };
  if (resolvedMode !== 'hold') return keys;
  if (
    Array.isArray(window) &&
    window.length &&
    !isDefaultReleaseWindow(window)
  ) {
    keys.release_window = window;
  }
  return keys;
};
